/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_First_NumberInputs */

const en_reference_field_first_number = /** @type {(inputs: Reference_Field_First_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First number`)
};

/**
* | output |
* | --- |
* | "First number" |
*
* @param {Reference_Field_First_NumberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_first_number = /** @type {((inputs?: Reference_Field_First_NumberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_First_NumberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_first_number(inputs)
});